import { EuiFlexGroup, EuiSuperSelect } from '@elastic/eui';
import * as S from './RangeFilter.styles';
interface RangeFilterProps {
  onChange: (p: RangeFilterProps['values']) => void;
  values: { min: string; max: string };
  data: Array<{
    value: string;
    inputDisplay: string;
  }>;
}
export const getDefaultRange = (data: RangeFilterProps['data']): RangeFilterProps['values'] => ({
  min: data[0].value,
  max: data[data.length - 1].value,
});

export const RangeFilter: (p: RangeFilterProps) => JSX.Element = ({ data, onChange, values }) => {
  const current = values;

  const minOptions = data.filter(({ value }) => parseInt(value) <= parseInt(current?.max ?? getDefaultRange(data).max));
  const maxOptions = data.filter(({ value }) => parseInt(value) >= parseInt(current?.min ?? getDefaultRange(data).min));

  return (
    <EuiFlexGroup direction="column">
      <EuiFlexGroup gutterSize={'none'}>
        <S.RangeFilterItem>
          <EuiSuperSelect
            options={minOptions}
            valueOfSelected={String(current?.min ?? getDefaultRange(data).min)}
            onChange={(v): void => {
              onChange({ max: values?.max ?? getDefaultRange(data).max, min: v });
            }}
          />
        </S.RangeFilterItem>
        <S.RangeFilterItem>
          <EuiSuperSelect
            options={maxOptions}
            valueOfSelected={String(current?.max ?? getDefaultRange(data).max)}
            onChange={(v): void => {
              onChange({ min: values?.min ?? getDefaultRange(data).min, max: v });
            }}
          />
        </S.RangeFilterItem>
      </EuiFlexGroup>
    </EuiFlexGroup>
  );
};
